import {CustomersTerritoriesAndAccountManagersImportTransformer} from "./customers-territories-and-account-managers";
import {ExternalCustomersImportTransformer} from "./external-customers";
import {ExternalVendorsImportTransformer} from "./external-vendors";
import {ExternalProductsImportTransformer} from "./external-products";
import {PartDescriptionImportTransformer} from "./part-description";
import {PartShortDescriptionImportTransformer} from "./part-short-description";
import {PartTitleImportTransformer} from "./part-title";
import {PartNotesImportTransformer} from "./part-notes";
import {PartPriceLevelImportTransformer} from "./part-price-level";
import {PartSerializabilityImportTransformer} from "./part-serializability";
import {PartDeliveryModeImportTransformer} from "./part-delivery-mode";
import {PartOnlineOrderEligibilityImportTransformer} from "./part-online-order-eligibility";
import {PartTechnicalInformationImportTransformer} from "./part-technical-information";
import {PartUpcImportTransformer} from "./part-upc";
import {PartVisibilityImportTransformer} from "./part-visibility";
import {PriceMatricesImportTransformer} from "./price-matrices";
import {ProductCategoryAssignmentImportTransformer} from "./product-category-assignment";
import {ProductDimensionsImportTransformer} from "./product-dimensions";
import {ProductPropertyOptionsImportTransformer} from "./product-property-options";
import {ProductPropertiesImportTransformer} from "./product-properties";
import {ProductVendorsImportTransformer} from "./product-vendors";
import {WarehouseAlertThresholdsImportTransformer} from "./warehouse-alert-thresholds";
import {ProductsFromAnotherPartnerImportTransformer} from "./products-from-another-partner";
import {ProductVisibilityToOtherPartnersImportTransformer} from "./product-visibility-to-other-partners";
import {ProductTagAssignmentImportTransformer} from "./product-tag-assignment";
import {ProductFormAssignmentImportTransformer} from "./product-form-assignment";
import {ProductRelationAssignmentImportTransformer} from "./product-relation-assignment";
import {ProductCodeAssignmentImportTransformer} from "./product-code-assignment";
import {ProductWarehouseAssignmentImportTransformer} from "./product-warehouse-assignment";
import {RemoveProductImportTransformer} from "./remove-product";
import {ProductFlatShippingRatesImportTransformer} from "./product-flat-shipping-rates";
import {SetInventoryAvailabilityImportTransformer} from "./set-inventory-availability";

/**
 * Maps datasource id → async transform(parsedRows, …extras, isFinalRun).
 * All import transformers live under this engine module.
 */
export const transformerRegistry = {
    customersTerritoriesAndAccountManagers: new CustomersTerritoriesAndAccountManagersImportTransformer(),
    externalCustomers: new ExternalCustomersImportTransformer(),
    externalVendors: new ExternalVendorsImportTransformer(),
    externalProducts: new ExternalProductsImportTransformer(),
    partDescription: new PartDescriptionImportTransformer(),
    partTitle: new PartTitleImportTransformer(),
    partShortDescription: new PartShortDescriptionImportTransformer(),
    partNotes: new PartNotesImportTransformer(),
    partPriceLevel: new PartPriceLevelImportTransformer(),
    partSerializability: new PartSerializabilityImportTransformer(),
    partDeliveryMode: new PartDeliveryModeImportTransformer(),
    partOnlineOrderEligibility: new PartOnlineOrderEligibilityImportTransformer(),
    productVisibilityToOtherPartners: new ProductVisibilityToOtherPartnersImportTransformer(),
    partTechnicalInformation: new PartTechnicalInformationImportTransformer(),
    partUPC: new PartUpcImportTransformer(),
    partVisibility: new PartVisibilityImportTransformer(),
    priceMatrices: new PriceMatricesImportTransformer(),
    productDimensions: new ProductDimensionsImportTransformer(),
    productCategoryAssignment: new ProductCategoryAssignmentImportTransformer(),
    productProperties: new ProductPropertiesImportTransformer(),
    productPropertyOptions: new ProductPropertyOptionsImportTransformer(),
    productVendors: new ProductVendorsImportTransformer(),
    warehouseAlertThresholds: new WarehouseAlertThresholdsImportTransformer(),
    productsFromAnotherPartner: new ProductsFromAnotherPartnerImportTransformer(),
    productWarehouseAssignment: new ProductWarehouseAssignmentImportTransformer(),
    setInventoryAvailability: new SetInventoryAvailabilityImportTransformer(),
    productTagAssignment: new ProductTagAssignmentImportTransformer(),
    productFormAssignment: new ProductFormAssignmentImportTransformer(),
    productRelationAssignment: new ProductRelationAssignmentImportTransformer(),
    productCodeAssignment: new ProductCodeAssignmentImportTransformer(),
    removeProduct: new RemoveProductImportTransformer(),
    productFlatShippingRates: new ProductFlatShippingRatesImportTransformer(),
};